import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "@mui/material";
import { SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN } from "../../../store/actionTypes/bplrt/equipmentActionType";
const EquipmentSuccessPrompt = () => {
  const dispatch = useDispatch();

  const {
    isSuccessPromptEquipmentPage: isSuccess,
    successMessageEquipmentPage: successMessage,
  } = useSelector((state) => state.bplrtEquip);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_SUCCESS_PROMPT_EQUIPMENT_BREAKDOWN, payload: false });
  };

  return (
    isSuccess && (
      <Alert
        sx={{ my: 2 }}
        severity="success"
        variant="filled"
        onClose={handleClose}
      >
        {successMessage}
      </Alert>
    )
  );
};

export default EquipmentSuccessPrompt;
